import BackIcon from "../../assets/icons/arrow_back.svg";
import NothingIcon from "../../assets/images/task-not-found-1 6.png";
import SickIcon from "../../assets/images/leave_images/sick_leave.png";
import CasualIcon from "../../assets/images/leave_images/casual_leave.png";
import PrivilegeIcon from "../../assets/images/leave_images/privilage_leave.png";
import MaternityIcon from "../../assets/images/leave_images/maternity : paternity_leave.png";
import MenstrualIcon from "../../assets/images/leave_images/menstrual_leave.png";
import EarnedIcon from "../../assets/images/leave_images/earned_leave.png";
import ESICIcon from "../../assets/images/leave_images/ESIC_leave.png";
import MiscarriageIcon from "../../assets/images/leave_images/miscarriage_leave.png";
import AttachmentIcon from "../../assets/icons/leave_icons/attachment.svg";
import TickIcon from "../../assets/icons/done_all_white.svg";
import CloseIcon from "../../assets/icons/close-2hite.svg";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  approvedLeaves,
  pendingLeaveApprovals,
  updateLeaveApprovals,
} from "../../store/AttendanceSlice/thunk";
import moment from "moment";
import InitialsCircle from "../InitialsCircle";
import CommonModal from "../../commonComponents/CommonModal";
import {
  ApprovalCardSkeletons,
  PendingCardSkeletons,
  ReporteeSkeleton,
} from "../../utils/skeleton";
import "./LeaveApproval.css";
import { getAllReportees } from "../../store/RequestSlice/thunk";
import { attendanceActions } from "../../store/AttendanceSlice";
import CustomMiniCalendar from "../../commonComponents/CustomMiniCalendar";
import CustomPagination from "../../commonComponents/CustomPagination";

const RemarksPopUp = ({
  regularisationSelected,
  setRegularisationSelected,
  onUpdateApprovals,
  closeremarksRef,
  updateApprovalResponseStatus,
}) => {
  return (
    <div className="flex flex-col rp-rm-pop">
      <div className="rm-rp-head">Please enter remarks before submit</div>

      <textarea
        autoFocus
        className="rm-rp-input"
        placeholder="Remarks for rejection"
        value={regularisationSelected?.remarks || ""}
        onChange={(e) =>
          setRegularisationSelected((prev) => ({
            ...prev,
            remarks: e.target.value,
          }))
        }
      />

      <div className="flex items-center mt-3 justify-center w-full">
        <div
          className="rp-approval-card-action-btn rp-reject"
          onClick={() => {
            onUpdateApprovals();
            closeremarksRef?.current?.click();
          }}
        >
          {updateApprovalResponseStatus === "PENDING"
            ? "Submitting..."
            : "Submit"}
        </div>
      </div>
    </div>
  );
};

const RevokePopUp = ({
  getLeaveIcon,
  historySelected,
  setHistorySelected,
  onRevokeLeave,
  updateApprovalResponseStatus,
}) => (
  <div className="lp-revoke-modal">
    <div className="lp-revoke-title">
      are you sure you want to revoke this approved leave?
    </div>
    <div className="lp-revoke-subtitle">
      Once revoked, this action cannot be undone.
    </div>
    <img
      className="lp-revoke-img"
      alt=""
      src={getLeaveIcon(historySelected?.leave_type)}
    />
    <input
      className="lp-revoke-comment"
      placeholder="Enter your comment here..."
      onChange={(e) => {
        setHistorySelected({
          ...historySelected,
          revoke_comment: e.target.value,
        });
      }}
      value={historySelected?.revoke_comment}
    />
    <div className="lp-revoke-btn" onClick={onRevokeLeave}>
      <span
        className="material-symbols-rounded"
        style={{ fontSize: "16px", color: "white" }}
      >
        block
      </span>
      <div className="lp-revoke-btn-text">
        {updateApprovalResponseStatus === "PENDING"
          ? "Revoking..."
          : "Revoke Leave"}
      </div>
    </div>
  </div>
);

const LeaveApproval = ({ changeStatus }) => {
  const dispatch = useDispatch();
  const openremarksRef = useRef();
  const closeremarksRef = useRef();
  const openRevokeRef = useRef();
  const closeRevokeRef = useRef();
  const openCommentRef = useRef();
  const closeCommentRef = useRef();
  const revokeRef = useRef();
  const dropdownRef = useRef();
  const miniCalRef = useRef();
  const LIMIT = 2000;

  const employeeID = useSelector((state) => state.auth.employeeID);
  const pendingLeaveRequests = useSelector(
    (state) => state.attendance.pendingLeaveRequests,
  );
  const pendingLeaveRequestsStatus = useSelector(
    (state) => state.attendance.pendingLeaveRequestsStatus,
  );
  const approvedLeaveRequests = useSelector(
    (state) => state.attendance.approvedLeaveRequests,
  );
  const approvedLeaveRequestsStatus = useSelector(
    (state) => state.attendance.approvedLeaveRequestsStatus,
  );
  const updateApprovalResponseStatus = useSelector(
    (state) => state.attendance.updateApprovalResponseStatus,
  );
  const getAllReporteesResponse = useSelector(
    (state) => state.request.getAllReporteesResponse,
  );
  const getAllReporteesResponseStatus = useSelector(
    (state) => state.request.getAllReporteesResponseStatus,
  );

  const [currentPage, setCurrentPage] = useState(1);
  const [leaveSelected, setLeaveSelected] = useState({});
  const [openRevoke, setOpenRevoke] = useState(false);
  const [historySelected, setHistorySelected] = useState({});
  const [reporteeList, setReporteeList] = useState(
    getAllReporteesResponse?.reportees,
  );
  const [search, setSearch] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [filteredApprovalList, setFilteredApprovallist] = useState([]);
  const [filteredPendingList, setFilteredPendinglist] = useState([]);
  const [commentView, setCommentView] = useState([]);
  const [showMiniCalendar, setShowMiniCalendar] = useState(false);
  const [datesSelected, setdatesSelected] = useState({});

  useEffect(() => {
    getPendingApprovals();
    getApprovedLeaveList();
    dispatch(getAllReportees({ offset: 0, limit: LIMIT }));

    const handleClickOutside = (event) => {
      if (revokeRef.current && !revokeRef.current.contains(event.target)) {
        setOpenRevoke(false);
        setHistorySelected({});
      }
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
      if (miniCalRef.current && !miniCalRef.current.contains(event.target)) {
        setShowMiniCalendar(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      dispatch(attendanceActions.resetLeaveApprovals());
    };
  }, []);

  useEffect(() => {
    if (selectedEmployee?.full_name) {
      console.log("reached here");

      const updatedList = [
        ...reporteeList?.filter((r) => r.full_name === search),
        ...reporteeList?.filter((r) => r.full_name !== search),
      ];
      setReporteeList(updatedList);

      console.log("selectedEmployee", selectedEmployee);

      getPendingApprovals(selectedEmployee?.full_name);
      getApprovedLeaveList(selectedEmployee?.full_name);
    } else {
      getPendingApprovals();
      getApprovedLeaveList();
    }
  }, [selectedEmployee, search]);

  useEffect(() => {
    if (approvedLeaveRequests) {
      console.log("inside approvedLeaveRequests here", approvedLeaveRequests);
      setFilteredApprovallist(approvedLeaveRequests?.body || []);
    }
  }, [approvedLeaveRequests]);

  useEffect(() => {
    if (pendingLeaveRequests) {
      console.log("inside pendingLeaveRequests here", pendingLeaveRequests);
      setFilteredPendinglist(pendingLeaveRequests?.body || []);
    }
  }, [pendingLeaveRequests]);

  useEffect(() => {
    getApprovedLeaveList(
      selectedEmployee?.full_name ? selectedEmployee?.full_name : "",
    );
  }, [currentPage]);

  const getPendingApprovals = (searchText = "") => {
    // setFilteredApprovallist([]);
    dispatch(
      pendingLeaveApprovals({
        employee_id: employeeID,
        length: "10",
        start: "0",
        search_term: searchText,
      }),
    );
  };

  const getApprovedLeaveList = (searchText = "") => {
    // setFilteredPendinglist([]);
    dispatch(
      approvedLeaves({
        employee_id: employeeID,
        length: "10",
        start: String((currentPage - 1) * 10),
        search_term: searchText,
      }),
    );
  };

  useEffect(() => {
    if (
      updateApprovalResponseStatus === "SUCCESS" ||
      updateApprovalResponseStatus === "ERROR"
    ) {
      // console.log("historySelected", historySelected);

      if (historySelected?.leave_id) {
        setFilteredApprovallist([]);
        closeRevokeRef.current.click();
        setHistorySelected({});
        getApprovedLeaveList();
        setTimeout(() => {
          getPendingApprovals();
        }, 1000);
      } else {
        setFilteredPendinglist([]);
        closeremarksRef.current.click();
        setLeaveSelected({});
        getPendingApprovals();
      }
    }
  }, [updateApprovalResponseStatus]);

  const onUpdateStatus = (data) => {
    setLeaveSelected(data);

    if (data?.status === "rejected") {
      openremarksRef.current.click();
    } else {
      onUpdateApprovals(data);
    }
  };

  const onUpdateApprovals = (data = {}) => {
    const payloadData = data?.leave_id ? data : leaveSelected;

    const payload = {
      employee_id: payloadData?.employee_id,
      leave_id: payloadData?.leave_id,
      status: payloadData?.status,
      remarks: payloadData?.remarks || "",
    };
    // console.log("update payload: ", payload);
    dispatch(updateLeaveApprovals(payload));
  };

  const onRevokeLeave = (data = {}) => {
    const payload = {
      employee_id: historySelected?.employee_id,
      leave_id: historySelected?.leave_id,
      status: "revoked",
      remarks: historySelected?.remarks || "",
      revoke_comment: historySelected?.revoke_comment || "",
    };
    console.log("update payload: ", payload);
    dispatch(updateLeaveApprovals(payload));
  };

  const onRevokeSelect = () => {
    setOpenRevoke(false);
    openRevokeRef.current.click();
  };

  const getLeaveIcon = (type) => {
    switch (type) {
      case "Sick Leave":
      case "SL":
        return SickIcon;
      case "Casual Leave":
      case "CL":
        return CasualIcon;
      case "Privilege Leave":
      case "PL":
        return PrivilegeIcon;
      case "Maternity":
      case "Maternity Leave":
      case "Paternity":
      case "Paternity Leave":
        return MaternityIcon;
      case "Menstrual":
      case "Menstrual Leave":
        return MenstrualIcon;
      case "Miscarriage":
      case "Miscarriage Leave":
        return MiscarriageIcon;
      case "Reserved PL":
      case "RPL":
        return EarnedIcon;
      case "ESIC":
        return ESICIcon;
      default:
        return CasualIcon;
    }
  };

  const CommentPopup = () => (
    <div className="flex flex-col lp-comment-pop">
      {commentView?.map((comment, i) => (
        <div className={`flex w-full space-4 ${i === 1 && "flex-row-reverse"}`}>
          <InitialsCircle
            size={36}
            borderRadius="12px"
            fullName={comment?.full_name}
          />
          <div className="lp-comment-popwrap">
            <div className="lp-comment-poptext">{comment?.comment}</div>
          </div>
        </div>
      ))}
      <div
        className="lp-comment-pop-btn"
        onClick={() => closeCommentRef.current.click()}
      >
        Done
      </div>
    </div>
  );

  return (
    <div className="leave-approval">
      <div className="lp-head">
        <div className="lp-head-left">
          <div className="lp-back-wrap" onClick={changeStatus}>
            <img src={BackIcon} alt="Back" className="lp-back-img" />
          </div>
          <div className="lp-header">leave approvals</div>
        </div>
        {getAllReporteesResponseStatus === "PENDING" && <ReporteeSkeleton />}
        {getAllReporteesResponseStatus === "SUCCESS" && (
          <div
            className="rp-avatar-group rp-reportee"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            {reporteeList?.map((reportee, index) => {
              const isSelected =
                search && reportee.full_name === search && index === 0;
              return (
                index < 3 && (
                  <div
                    key={reportee.employee_id || index}
                    className="rp-avatar"
                    style={{
                      // border: "none",
                      border: isSelected ? "2px solid #253037" : "none",
                      borderRadius: "12px",
                      height: "36px",
                      width: "36px",
                    }}
                  >
                    <InitialsCircle
                      fullName={reportee.full_name}
                      size={36}
                      borderRadius="12px"
                    />
                  </div>
                )
              );
            })}
            {reporteeList?.length === 0 && (
              <>
                <div className="rp-avatar" />
                <div className="rp-avatar" />
                <div className="rp-avatar" />
              </>
            )}
            <div className="rp-avatar-arrow-wrap">
              <span className="rp-avatar-arrow">▾</span>
            </div>
          </div>
        )}
      </div>
      {showDropdown && (
        <div className="rp-dropdown-popup" ref={dropdownRef}>
          <div style={{ position: "relative", width: "100%" }}>
            <input
              className="rp-search-input"
              style={{
                width: "100%",
                paddingRight: "30px",
                boxSizing: "border-box",
              }}
              placeholder="Search reportees"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                if (!e.target.value) {
                  setSelectedEmployee(null);
                  setShowDropdown(false);
                }
              }}
            />
            {search && (
              <span
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  fontSize: "14px",
                  color: "#999",
                  lineHeight: 1,
                }}
                onClick={() => {
                  setSearch("");
                  setSelectedEmployee(null);
                  setFilteredApprovallist(approvedLeaveRequests?.body);
                  setFilteredPendinglist(pendingLeaveRequests?.body);
                }}
              >
                ✕
              </span>
            )}
          </div>
          <div className="drop-users">
            {(reporteeList || []).map((m, i) => {
              const isSelected =
                selectedEmployee?.employee_id === m.employee_id;
              return (
                <div
                  key={i}
                  className="rp-dropdown-item"
                  style={{
                    cursor: "pointer",
                    backgroundColor: isSelected ? "#FFF8E1" : "transparent",
                  }}
                  onClick={() => {
                    setSearch(m.full_name);
                    setSelectedEmployee(m);
                    setShowDropdown(false);
                  }}
                >
                  <InitialsCircle size={16} fullName={m.full_name} />
                  <div className="rp-avatar-text">{m.full_name}</div>
                </div>
              );
            })}
          </div>
        </div>
      )}
      {pendingLeaveRequestsStatus === "PENDING" && <ApprovalCardSkeletons />}
      <div className="lp-scroll-content w-full">
        <div className="lp-approval-list">
          {!pendingLeaveRequests?.body?.length &&
            pendingLeaveRequestsStatus !== "PENDING" && (
              <>
                <div></div>
                <div className="flex flex-col items-center justify-center h-full w-full">
                  <img className="rp-empty-ico" src={NothingIcon} alt="" />
                  <div className="rp-empty-text">
                    No pending requests available
                  </div>
                </div>
              </>
            )}
          {filteredPendingList?.map((approval, index) => (
            <div className="lp-approval-card" key={index}>
              <div className="lp-approval-card-header">
                <InitialsCircle
                  fullName={approval?.full_name}
                  size={40}
                  borderRadius="8px"
                />
                <div className="lp-approval-card-name">
                  {approval.full_name}
                </div>
                <div className="lp-approval-card-id">
                  ID #{approval.employee_id}
                </div>
              </div>
              <div className="lp-approval-card-body">
                <div className="lp-approval-card-date-wrap">
                  <div className="lp-approval-card-days-wrap">
                    <div className="lp-approval-card-days">
                      {approval.applied_days} Days
                    </div>
                  </div>
                  <div className="lp-approval-card-range-wrap">
                    <div className="lp-approval-card-start-date-wrap">
                      <div className="lp-approval-start-date">
                        {moment(approval.start_date).format("DD MMM'YY")}
                      </div>
                    </div>
                    <div className="lp-approval-card-end-date-wrap">
                      <div className="lp-approval-end-date">
                        {moment(approval.end_date).format("DD MMM'YY")}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="lp-approval-desc">
                  <div className="lp-approval-card-type">
                    <img
                      className="lp-approval-type-ico"
                      src={
                        approval?.leave_name === "Sick leave"
                          ? SickIcon
                          : approval?.leave_name === "Casual leave"
                            ? CasualIcon
                            : approval?.leave_name === "Privilege leave"
                              ? PrivilegeIcon
                              : approval?.leave_name === "Maternity leave"
                                ? MaternityIcon
                                : MenstrualIcon
                      }
                      alt={approval.leave_name}
                    />
                    <div className="lp-approval-card-type-name">
                      {approval.leave_name}
                    </div>
                  </div>
                  <div className="lp-approval-card-comment">
                    {approval.leave_remarks}
                  </div>
                </div>
                <div className="lp-approval-card-reason-wrap">
                  {approval?.s3_url && (
                    <img
                      className="lp-approval-card-attach-ico"
                      src={AttachmentIcon}
                      alt="Attachment Icon"
                    />
                  )}
                  {approval.reason && (
                    <div className="lp-approval-card-reason-text-wrap">
                      <div className="lp-approval-card-reason-text">
                        {approval.reason}
                      </div>
                    </div>
                  )}
                </div>
                <div className="rp-approval-card-actions">
                  <div className="flex">
                    <div
                      className="rp-approval-card-action-btn rp-approve"
                      onClick={() => {
                        if (updateApprovalResponseStatus === "PENDING") return;
                        onUpdateStatus({ ...approval, status: "approved" });
                      }}
                      disabled={updateApprovalResponseStatus === "PENDING"}
                    >
                      <img
                        src={TickIcon}
                        className="rp-approval-card-ico"
                        alt=""
                      />
                      {updateApprovalResponseStatus === "PENDING" &&
                      leaveSelected?.leave_id === approval.leave_id &&
                      leaveSelected?.status === "approved"
                        ? "Approving..."
                        : "Approve"}
                    </div>

                    <div
                      className="rp-approval-card-action-btn rp-reject"
                      onClick={() => {
                        if (updateApprovalResponseStatus === "PENDING") return;
                        onUpdateStatus({ ...approval, status: "rejected" });
                      }}
                    >
                      <img
                        src={CloseIcon}
                        className="rp-approval-card-ico"
                        alt=""
                      />
                      Reject
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="lp-approval-table">
          <div className="lp-approval-table-header">approval history</div>
          {approvedLeaveRequestsStatus === "PENDING" && (
            <PendingCardSkeletons />
          )}
          <div className="lp-approval-table-content w-full">
            {!approvedLeaveRequests?.body?.length &&
              approvedLeaveRequestsStatus !== "PENDING" && (
                <div className="flex flex-col items-center justify-center h-full w-full">
                  <img className="rp-empty-ico" src={NothingIcon} alt="" />
                  <div className="rp-empty-text">
                    No approved requests available
                  </div>
                </div>
              )}
            {filteredApprovalList?.map((history, index) => (
              <div className="lp-approval-item w-full" key={index}>
                <div className="lp-approval-item-header">
                  <InitialsCircle fullName={history?.full_name} size={40} />
                  <div className="lp-approval-item-info">
                    <div className="lp-approval-item-name">
                      {history?.full_name}
                    </div>
                    <div className="lp-approval-item-id">
                      #{history?.employee_id}
                    </div>
                  </div>
                </div>
                <div className="lp-approval-item-left">
                  <div className="lp-approval-day-wrap">
                    <div className="lp-approval-day-text">
                      {history?.applied_days} Days
                      <span
                        className="info-dot"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (
                            showMiniCalendar &&
                            datesSelected?.leave_id === history?.leave_id
                          ) {
                            setShowMiniCalendar(false);
                            return;
                          }
                          setdatesSelected(history);
                          setShowMiniCalendar(true);
                        }}
                        onMouseEnter={() => {
                          setdatesSelected(history);
                          setShowMiniCalendar(true);
                        }}
                        onMouseLeave={() => {
                          setShowMiniCalendar(false);
                        }}
                      >
                        i
                      </span>
                    </div>
                    {showMiniCalendar &&
                      datesSelected?.leave_id === history?.leave_id && (
                        <div className="lp-mini-wrap" ref={miniCalRef}>
                          <CustomMiniCalendar
                            startDate={history?.start_date}
                            endDate={history?.end_date}
                            totalDays={history?.applied_days}
                          />
                        </div>
                      )}
                  </div>

                  <div className="lp-approval-range">
                    <div className="lp-approval-start-wrap">
                      <div className="lp-approval-start-text">
                        {moment(history.start_date).format("DD MMM'YY")}
                      </div>
                    </div>

                    <div className="lp-approval-end-wrap">
                      <div className="lp-approval-end-text">
                        {moment(history.end_date).format("DD MMM'YY")}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="lp-approval-middle">
                  <div
                    className="lp-approval-type"
                    style={{
                      borderRight: history?.s3_url
                        ? "1px solid #e4eaf0"
                        : "none",
                      width: history?.s3_url ? "104px" : "auto",
                    }}
                  >
                    <img
                      className="lp-approval-type-img"
                      src={
                        history?.leave_name === "Sick leave"
                          ? SickIcon
                          : history?.leave_name === "Casual leave"
                            ? CasualIcon
                            : history?.leave_name === "Privilege leave"
                              ? PrivilegeIcon
                              : history?.leave_name === "Maternity leave"
                                ? MaternityIcon
                                : history?.leave_name === "Menstrual leave"
                                  ? MenstrualIcon
                                  : ""
                      }
                      alt=""
                    />
                    <div className="lp-approval-type-text">
                      {history?.leave_name}
                    </div>
                  </div>

                  <div className="lp-approval-reason-text">
                    {history?.reason}
                  </div>

                  {history?.s3_url && (
                    <div
                      className="lp-approval-attachment"
                      onClick={() => window.open(history?.s3_url, "_blank")}
                    >
                      <span
                        className="material-symbols-rounded"
                        style={{ fontSize: "12px", color: "black" }}
                      >
                        docs
                      </span>
                      <div className="lp-approval-attachment-text">1</div>
                    </div>
                  )}
                </div>

                <div className="lp-approval-right">
                  {(history?.approver_remarks || history?.leave_remarks) && (
                    <div
                      className="lp-ap-remark-wrap cursor-pointer"
                      onClick={() => {
                        const remarkPayload = [
                          history?.approver_remarks && {
                            comment: history.approver_remarks,
                            full_name: history.full_name,
                          },
                          history?.leave_remarks && {
                            comment: history.leave_remarks,
                            full_name: history.full_name,
                          },
                        ].filter(Boolean);

                        setCommentView(remarkPayload);
                        openCommentRef.current.click();
                      }}
                    >
                      <span
                        className="material-symbols-rounded"
                        style={{ fontSize: "12px", color: "black" }}
                      >
                        comment
                      </span>
                      <div className="lp-ap-remark-text">
                        {history?.approver_remarks && history?.leave_remarks
                          ? 2
                          : 1}
                      </div>
                    </div>
                  )}
                  <div
                    className={`lp-approval-status-wrap lp-approval-status-${history?.leave_approval_status?.toLowerCase()} ${historySelected?.leave_id === history?.leave_id && "border-2"}`}
                    onClick={() => {
                      if (
                        history?.leave_approval_status?.toLowerCase() ===
                        "approved"
                      ) {
                        setOpenRevoke(true);
                        setHistorySelected(history);
                      }
                    }}
                  >
                    <div className="lp-approval-status-text uppercase">
                      {history?.leave_approval_status}
                    </div>
                  </div>
                  {openRevoke &&
                    historySelected?.leave_id === history?.leave_id && (
                      <div className="lp-approval-revoke-popup" ref={revokeRef}>
                        <div className="lp-revoke-exist-wrap">
                          <span
                            className="material-symbols-rounded"
                            style={{ fontSize: "16px", color: "green" }}
                          >
                            done_all
                          </span>
                          <div className="lp-revoke-exist-text">Approve</div>
                        </div>
                        <div
                          className="lp-revoke-wrap"
                          onClick={onRevokeSelect}
                        >
                          <span
                            className="material-symbols-rounded"
                            style={{ fontSize: "16px", color: "red" }}
                          >
                            block
                          </span>
                          <div className="lp-revoke-text">Revoke</div>
                        </div>
                      </div>
                    )}
                </div>
              </div>
            ))}
            {(filteredApprovalList?.length && (
              <div className="lp-paginate">
                <CustomPagination
                  totalCount={approvedLeaveRequests?.total_count}
                  itemsPerPage={10}
                  currentPage={currentPage}
                  onPageChange={setCurrentPage}
                />
              </div>
            )) ||
              ""}
          </div>
        </div>
      </div>

      <CommonModal
        openRef={openremarksRef}
        closeRef={closeremarksRef}
        id="remarkpopup"
        hideCloseButton={true}
        content={
          <RemarksPopUp
            regularisationSelected={leaveSelected}
            setRegularisationSelected={setLeaveSelected}
            onUpdateApprovals={onUpdateApprovals}
            closeremarksRef={closeremarksRef}
            updateApprovalResponseStatus={updateApprovalResponseStatus}
          />
        }
        outSideCloseButton={true}
        disabled={false}
        size="sm"
        // backDrop={true}
        modalStyle={{
          borderRadius: "24px",
          background: "#FFF",
          boxShadow: "0 4px 40px rgba(23,33,40,0.10)",
          minHeight: "96px",
          minWidth: "428px",
        }}
        modalBodyStyle={{
          padding: "0px",
        }}
      />

      <CommonModal
        openRef={openRevokeRef}
        closeRef={closeRevokeRef}
        id="revokepopup"
        hideCloseButton={true}
        content={
          <RevokePopUp
            getLeaveIcon={getLeaveIcon}
            historySelected={historySelected}
            setHistorySelected={setHistorySelected}
            onRevokeLeave={onRevokeLeave}
            updateApprovalResponseStatus={updateApprovalResponseStatus}
          />
        }
        onModalClose={() => setHistorySelected({})}
        outSideCloseButton={true}
        disabled={false}
        size="md"
        modalStyle={{
          borderRadius: "24px",
          background: "#FFF",
          boxShadow: "0 4px 40px rgba(23,33,40,0.10)",
          maxHeight: "304px",
          maxWidth: "428px",
        }}
        modalBodyStyle={{
          padding: "0px",
        }}
      />
      <CommonModal
        openRef={openCommentRef}
        closeRef={closeCommentRef}
        id="commentpopup"
        hideCloseButton={true}
        content={<CommentPopup />}
        onModalClose={() => setHistorySelected({})}
        outSideCloseButton={true}
        disabled={false}
        size="md"
        modalStyle={{
          borderRadius: "28px",
          background: "#FFF",
          boxShadow: "0 4px 40px rgba(23,33,40,0.10)",
          // minHeight: "96px",
          maxWidth: "428px",
        }}
        modalBodyStyle={{
          padding: "0px",
        }}
      />
    </div>
  );
};
export default LeaveApproval;
